// extracted by mini-css-extract-plugin
export default {"reverse-order":"_1itwbd1","reverseOrder":"_1itwbd1"};